import React from "react";

function iconProps(cls = "h-4 w-4") {
  return { className: cls, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.8 };
}
const IconWifi = () => (<svg {...iconProps()}><path d="M3 9a16 16 0 0 1 18 0" /><path d="M6 12a11 11 0 0 1 12 0" /><path d="M9 15a6 6 0 0 1 6 0" /><circle cx="12" cy="19" r="1.2" /></svg>);
const IconPhone = () => (<svg {...iconProps()}><path d="M22 16.92v2a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 3.2 2 2 0 0 1 4.11 1h2a2 2 0 0 1 2 1.72c.12.91.34 1.79.66 2.63.23.61.06 1.31-.4 1.77l-1 1a15.9 15.9 0 0 0 6 6l1-1a1.6 1.6 0 0 1 1.77-.4c.84.32 1.72.54 2.63.66A2 2 0 0 1 22 16.92Z" /></svg>);
const IconPlay = () => (<svg {...iconProps()}><path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" /><path d="M10 8l6 4-6 4z" /></svg>);
const IconShield = () => (<svg {...iconProps()}><path d="M12 2l7 4v6c0 5-3.5 8-7 10-3.5-2-7-5-7-10V6l7-4z" /><path d="M9.5 12.5l1.8 1.8 3.8-3.8" /></svg>);
const IconHome = () => (<svg {...iconProps()}><path d="M3 10.5 12 3l9 7.5" /><path d="M5 10v9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-9" /><path d="M9 21V12h6v9" /></svg>);

function ArrowRight({ className = "h-5 w-5" }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M5 12h13" />
      <path d="M13 6l6 6-6 6" />
    </svg>
  );
}

/** Sweep de luz no texto (sem distorções) */
function LightSweepText({
  children,
  className = "",
  durationSec = 4.2,
}: {
  children: React.ReactNode;
  className?: string;
  durationSec?: number;
}) {
  return (
    <span
      className={`sweep-text ${className}`}
      style={{ ["--sweep-duration" as any]: `${durationSec}s` } as React.CSSProperties}
    >
      {children}
    </span>
  );
}

function FeatureChip({ icon, label }: { icon: React.ReactNode; label: string }) {
  return (
    <div
      className="group relative flex items-center gap-2.5 rounded-full border border-white/10 bg-white/[.06] px-4 py-2.5 text-[15px] text-white/85 transition hover:border-white/20 hover:bg-white/[.08]"
      aria-label={label}
      title={label}
    >
      <span
        className="grid place-items-center h-8 w-8 rounded-full text-white"
        style={{
          background: "linear-gradient(135deg, rgba(255,0,100,.95), rgba(255,77,145,.9))",
          boxShadow: "0 10px 22px -12px rgba(255,0,100,.55)",
        }}
      >
        <span className="opacity-95">{icon}</span>
      </span>
      <span className="pr-1">{label}</span>
    </div>
  );
}

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      {/* Fundo estático */}
      <div className="absolute inset-0 bg-hero bg-cover bg-center" />

      {/* Aurora sutil */}
      <div className="pointer-events-none absolute inset-0 glow-aurora" />

      {/* Vinhetas */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/25 via-transparent to-black/70" />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-20 bg-gradient-to-b from-transparent to-[#0b0b0c]" />

      {/* Conteúdo */}
      <div className="relative flex min-h-[86vh] items-start">
        <div className="max-w-7xl mx-auto w-full px-4 pt-28 md:pt-36 pb-10">
          <div
            className="
              glass rounded-2xl shadow-card bg-white/[.07] border border-white/10 ring-1 ring-white/10
              max-w-[56rem] md:max-w-[58rem] lg:max-w-[60rem]
              px-8 md:px-12 lg:px-14
              py-10 md:py-14
              glow-card
            "
          >
            {/* Kicker */}
            <p className="kicker text-[12px] uppercase text-white/70 tracking-[0.28em]">
              Conectividade inteligente
            </p>

            {/* Headline com varredura de luz (sem parallax) */}
            <h1
              className="
    mt-3 text-[34px] md:text-[54px] font-extrabold leading-[1.1] tracking-tight
    relative overflow-visible
  "
            >
              <span className="inline-block pb-[0.08em]">
                <LightSweepText className="block" durationSec={4.2}>
                  Condomínios Digitais
                </LightSweepText>
              </span>

              {/* by LOViZ mais próximo da linha acima */}
              <span className="relative block -mt-[0.22em] md:-mt-[0.28em] -translate-y-[0.02em] pb-[0.06em]">
                <LightSweepText className="text-[0.7em] md:text-[0.65em] font-extrabold" durationSec={5}>
                  by LOViZ
                </LightSweepText>
                <i className="headline-underline" />
              </span>
            </h1>
            {/* Chips */}
            <div className="mt-7 flex flex-wrap gap-x-3.5 gap-y-3">
              <FeatureChip icon={<IconWifi />} label="Internet" />
              <FeatureChip icon={<IconPhone />} label="Telefonia" />
              <FeatureChip icon={<IconPlay />} label="Streaming" />
              <FeatureChip icon={<IconShield />} label="Segurança" />
              <FeatureChip icon={<IconHome />} label="Automação" />
            </div>

            {/* Descrição */}
            <p className="mt-7 text-[15.5px] text-white/80 max-w-2xl leading-relaxed">
              Uma única infraestrutura para serviços essenciais do seu condomínio — padrão premium,
              estabilidade e suporte especializado.
            </p>

            {/* CTAs */}
            <div className="mt-8 flex flex-col sm:flex-row gap-3.5">
              <a href="#cta" className="btn btn-primary group px-6 py-3.5 text-[15.5px] rounded-2xl">
                Projeto gratuito
                <ArrowRight className="ml-2 h-5 w-5 transition-transform duration-200 group-hover:translate-x-0.5" />
              </a>
              <a href="#como" className="btn btn-ghost group px-6 py-3.5 text-[15.5px] rounded-2xl">
                Ver como funciona
                <ArrowRight className="ml-2 h-5 w-5 opacity-80 transition-transform duration-200 group-hover:translate-x-0.5" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* CSS do sweep + underline; sem parallax */}
      <style>{`
        /* Texto com varredura de luz */
        .sweep-text {
          position: relative;
          display: inline-block;
          overflow: visible;               /* garante que a pintura não seja clipada */
          padding-bottom: .08em;           /* expande caixa de pintura dos descendentes */
          margin-bottom: -.08em;           /* neutraliza o aumento (layout inalterado) */

          background-image:
            linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,.0) 35%, rgba(255,255,255,.75) 50%, rgba(255,255,255,.0) 65%, rgba(255,255,255,0) 100%),
            linear-gradient(90deg, #ffffff 0%, #ffffff 100%); /* base branca */
          background-size: 200% 100%, 100% 100%;
          background-repeat: no-repeat;
          background-position: -100% 0, 0 0;

          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent; /* evita clipping no WebKit */
          color: transparent;

          animation: sweep var(--sweep-duration, 4s) ease-in-out infinite;
        }
        @keyframes sweep {
          0%   { background-position: -120% 0, 0 0; }
          55%  { background-position: 120% 0, 0 0; }
          100% { background-position: 120% 0, 0 0; }
        }

        /* Underline com brilho que desliza */
        .headline-underline {
          position: absolute;
          left: 0; right: 0;
          bottom: -0.25em;
          height: 2px;
          border-radius: 9999px;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,.6), transparent);
          opacity: .7;
          overflow: hidden;
          pointer-events: none;
        }
        .headline-underline::after {
          content: "";
          position: absolute; inset: 0;
          background: linear-gradient(90deg, transparent 0%, rgba(255,0,100,.9) 45%, rgba(255,255,255,.95) 50%, rgba(255,77,145,.9) 55%, transparent 100%);
          transform: translateX(-100%);
          animation: underlineSweep 3.6s ease-in-out infinite;
        }
        @keyframes underlineSweep {
          0%   { transform: translateX(-120%); }
          50%  { transform: translateX(0%); }
          100% { transform: translateX(120%); }
        }

        /* Aurora suave no fundo */
        .glow-aurora::before,
        .glow-aurora::after {
          content: "";
          position: absolute;
          inset: -20%;
          filter: blur(70px);
          opacity: .55;
          pointer-events: none;
          background:
            radial-gradient(40% 35% at 20% 30%, rgba(255,0,100,.32), transparent 60%),
            radial-gradient(35% 30% at 80% 70%, rgba(255,95,160,.26), transparent 60%),
            radial-gradient(25% 25% at 60% 20%, rgba(255,255,255,.06), transparent 60%);
          animation: auroraFloat 16s ease-in-out infinite;
        }
        .glow-aurora::after { opacity: .35; transform: scale(1.05) rotate(8deg); animation-duration: 22s; animation-direction: alternate; }
        @keyframes auroraFloat {
          0%   { transform: translate3d(-6%, -4%, 0) scale(1); }
          50%  { transform: translate3d(6%, 4%, 0) scale(1.03); }
          100% { transform: translate3d(-6%, -4%, 0) scale(1); }
        }

        /* Pulso sutil do card (sem distorção) */
        .glow-card {
          box-shadow: 0 22px 70px -26px rgba(255,0,100,.24), inset 0 0 0 1px rgba(255,255,255,.08);
          animation: cardPulse 5.5s ease-in-out infinite;
        }
        @keyframes cardPulse {
          0%, 100% { box-shadow: 0 22px 70px -26px rgba(255,0,100,.24), inset 0 0 0 1px rgba(255,255,255,.08); }
          50%      { box-shadow: 0 34px 100px -24px rgba(255,0,100,.42), inset 0 0 0 1px rgba(255,255,255,.12); }
        }

        /* A11y: reduzir movimento */
        @media (prefers-reduced-motion: reduce) {
          .sweep-text, .headline-underline::after, .glow-aurora::before, .glow-aurora::after, .glow-card { animation: none !important; }
        }
      `}</style>
    </section>
  );
}
